module.exports = __webpack_public_path__ + "static/media/icochamada.936cd140.svg";